import React from "react";
import { render } from "react-dom";
import { ApolloProvider } from "@apollo/client";
import { client } from "helpers/apolloClientLink";
import { Provider } from "react-redux";
import LanguageProvider from "components/LanguageProvider/LanguageProvider";
import useGetTranslationFiles from "components/LanguageProvider/utils/getTranslationFiles";
import configureStore from "../campaign/store/configureStore";
import TeamPage from "./TeamPage";

const store = configureStore();

const { campaignId } = window.Chuffed.teamsInit;
const { campaignImage } = window.Chuffed.teamsInit;
const { campaignVideo } = window.Chuffed.teamsInit;
const { currencySymbol } = window.Chuffed.teamsInit;
const fundraiserSignup = window.Chuffed.fundraiserSignup && window.Chuffed.campaignInit.fundraiserSignup;
const { fundraisersLeaderboard } = window.Chuffed.teamsInit;
const { paymentUrl } = window.Chuffed.teamsInit;
const { team } = window.Chuffed.teamsInit;

const Team = () => {
  const { translations } = useGetTranslationFiles();
  return (
    <Provider store={store}>
      <LanguageProvider translations={translations}>
        <TeamPage
          team={team}
          campaignId={campaignId}
          paymentUrl={paymentUrl}
          campaignImage={campaignImage}
          fundraiserSignup={fundraiserSignup}
          fundraisersLeaderboard={fundraisersLeaderboard}
          campaignVideo={campaignVideo}
          currencySymbol={currencySymbol}
        />
      </LanguageProvider>
    </Provider>
  );
};

render(
  <ApolloProvider client={client}><Team /></ApolloProvider>,
  document.getElementById("js-team-page-base"),
);
